var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulletsbg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 115,
    viewBox: "0 0 101 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2687 9.74577C6.62624 9.74577 8.5374 7.56411 8.5374 4.87289C8.5374 2.18167 6.62624 0 4.2687 0C1.91116 0 0 2.18167 0 4.87289C0 7.56411 1.91116 9.74577 4.2687 9.74577Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3202 9.74577C29.6778 9.74577 31.5889 7.56411 31.5889 4.87289C31.5889 2.18167 29.6778 0 27.3202 0C24.9627 0 23.0515 2.18167 23.0515 4.87289C23.0515 7.56411 24.9627 9.74577 27.3202 9.74577Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2237 9.74577C53.5812 9.74577 55.4924 7.56411 55.4924 4.87289C55.4924 2.18167 53.5812 0 51.2237 0C48.8661 0 46.955 2.18167 46.955 4.87289C46.955 7.56411 48.8661 9.74577 51.2237 9.74577Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3202 36.0594C29.6778 36.0594 31.5889 33.8778 31.5889 31.1866C31.5889 28.4953 29.6778 26.3137 27.3202 26.3137C24.9627 26.3137 23.0515 28.4953 23.0515 31.1866C23.0515 33.8778 24.9627 36.0594 27.3202 36.0594Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2237 36.0594C53.5812 36.0594 55.4924 33.8778 55.4924 31.1866C55.4924 28.4953 53.5812 26.3137 51.2237 26.3137C48.8661 26.3137 46.955 28.4953 46.955 31.1866C46.955 33.8778 48.8661 36.0594 51.2237 36.0594Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2237 63.3473C53.5812 63.3473 55.4924 61.1657 55.4924 58.4745C55.4924 55.7832 53.5812 53.6016 51.2237 53.6016C48.8661 53.6016 46.955 55.7832 46.955 58.4745C46.955 61.1657 48.8661 63.3473 51.2237 63.3473Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4213 9.74577C75.7788 9.74577 77.69 7.56411 77.69 4.87289C77.69 2.18167 75.7788 0 73.4213 0C71.0638 0 69.1526 2.18167 69.1526 4.87289C69.1526 7.56411 71.0638 9.74577 73.4213 9.74577Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4213 36.0594C75.7788 36.0594 77.69 33.8778 77.69 31.1866C77.69 28.4953 75.7788 26.3137 73.4213 26.3137C71.0638 26.3137 69.1526 28.4953 69.1526 31.1866C69.1526 33.8778 71.0638 36.0594 73.4213 36.0594Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4213 63.3473C75.7788 63.3473 77.69 61.1657 77.69 58.4745C77.69 55.7832 75.7788 53.6016 73.4213 53.6016C71.0638 53.6016 69.1526 55.7832 69.1526 58.4745C69.1526 61.1657 71.0638 63.3473 73.4213 63.3473Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4213 88.6866C75.7788 88.6866 77.69 86.5049 77.69 83.8137C77.69 81.1225 75.7788 78.9408 73.4213 78.9408C71.0638 78.9408 69.1526 81.1225 69.1526 83.8137C69.1526 86.5049 71.0638 88.6866 73.4213 88.6866Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4728 9.74577C98.8303 9.74577 100.742 7.56411 100.742 4.87289C100.742 2.18167 98.8303 0 96.4728 0C94.1153 0 92.2041 2.18167 92.2041 4.87289C92.2041 7.56411 94.1153 9.74577 96.4728 9.74577Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4728 36.0594C98.8303 36.0594 100.742 33.8778 100.742 31.1866C100.742 28.4953 98.8303 26.3137 96.4728 26.3137C94.1153 26.3137 92.2041 28.4953 92.2041 31.1866C92.2041 33.8778 94.1153 36.0594 96.4728 36.0594Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4728 63.3473C98.8303 63.3473 100.742 61.1657 100.742 58.4745C100.742 55.7832 98.8303 53.6016 96.4728 53.6016C94.1153 53.6016 92.2041 55.7832 92.2041 58.4745C92.2041 61.1657 94.1153 63.3473 96.4728 63.3473Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4728 88.6866C98.8303 88.6866 100.742 86.5049 100.742 83.8137C100.742 81.1225 98.8303 78.9408 96.4728 78.9408C94.1153 78.9408 92.2041 81.1225 92.2041 83.8137C92.2041 86.5049 94.1153 88.6866 96.4728 88.6866Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4728 115C98.8303 115 100.742 112.818 100.742 110.127C100.742 107.436 98.8303 105.254 96.4728 105.254C94.1153 105.254 92.2041 107.436 92.2041 110.127C92.2041 112.818 94.1153 115 96.4728 115Z",
    fill: "#C6C6C6",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletsbg);
export default __webpack_public_path__ + "static/media/bulletsbg.b1bc74b3421feb6ea229f68737de150b.svg";
export { ForwardRef as ReactComponent };